import { useCallback } from 'react';
import { useGetStreamData } from '../useGetStreamData';

export const useUpdateRemoteMode = () => {
	const { getStreamData } = useGetStreamData();

	const updateRemoteMode = useCallback(
		(prevState, stream) => {
			const remote = { ...prevState.remote };
			if (stream['/remote_mode']) {
				const request = JSON.parse(getStreamData(stream, '/remote_mode'));
				remote.request = request.request;
				remote.approval = request.approval;
			}
			return remote;
		},
		[getStreamData],
	);

	return { updateRemoteMode };
};
